<template>
    <nav class="flex items-center justify-between text-bhav-blue-300 text-sm relative z-10 px-3 py-2">
        <div class="flex-0 flex justify-between sm:justify-end gap-3 items-center">
            <p v-if="count > to" class="text-sm leading-5">
                Showing
                <span class="font-medium">{{ from + 1 }}</span>
                to
                <span class="font-medium">{{ to }}</span>
                of
                <span class="font-medium">{{ count }}</span>
                Results
            </p>
            <p v-else class="text-sm leading-5">
                Showing All Results
            </p>
        </div>
        <div class="flex-1 flex justify-center items-center" v-if="count">
            <button :disabled="page == 1" @click="$emit('flip', 1)" type="button"
                title="Navigate to the first page"
                :class="{ 'opacity-50 cursor-not-allowed': page == 1,  'hover:text-bhav-blue-500 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 active:bg-gray-100 active:text-gray-700' : page > 1}"
                class="relative inline-flex items-center px-2 py-1 text-sm leading-5 font-medium rounded-md transition ease-in-out duration-150">
                <span class="far fa-chevrons-left"></span>
            </button>
            <button :disabled="page == 1" @click="$emit('flip', 'prev')" type="button"
                title="Navigate to the previous page"
                :class="{ 'opacity-50 cursor-not-allowed': page == 1,  'hover:text-bhav-blue-500 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 active:bg-gray-100 active:text-gray-700' : page > 1}"
                class="relative inline-flex items-center px-2 py-1 text-sm leading-5 font-medium rounded-md transition ease-in-out duration-150">
                <span class="far fa-chevron-left"></span>
            </button>
            <p class="flex justify-center gap-2 items-center">
                <input type="number" min="1" :max="max" class="[appearance:textfield] text-center px-3 py-2 bg-bhav-cool-gray-50 rounded-md [&::-webkit-outer-spin-button]:appearance-none 
    [&::-webkit-inner-spin-button]:appearance-none" @change="(e) => $emit('flip', e.target.value)" :value="page">
                <span aria-hidden="true"> of </span>
                <span :title="`${page} of ${max} pages`">{{ max }}</span>
            </p>
            <button :disabled="!max || page == max" @click="$emit('flip', 'next')" type="button"
                title="Navigate to the next page"
                :class="{ 'opacity-50 cursor-not-allowed': !max || page == max, 'hover:text-bhav-blue-500 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 active:bg-gray-100 active:text-gray-700': max || page < max }"
                class="relative inline-flex items-center px-2 py-1 text-sm leading-5 font-medium rounded-md transition ease-in-out duration-150">
                <span class="far fa-chevron-right"></span>
            </button>
            <button :disabled="!max || page == max" @click="$emit('flip', max)" type="button"
                title="Navigate to the last page"
                :class="{ 'opacity-50 cursor-not-allowed': !max || page == max, 'hover:text-bhav-blue-500 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 active:bg-gray-100 active:text-gray-700': max || page < max }"
                class="relative inline-flex items-center px-2 py-1 text-sm leading-5 font-medium rounded-md transition ease-in-out duration-150">
                <span class="far fa-chevrons-right"></span>
            </button>
        </div>
        <div class="flex-0 flex justify-between sm:justify-end gap-3 items-center">
            <slot name="end"></slot>
            <SelectField v-model="limit" label="Rows Per Page" :options="getLimits" :allow-null="false" />
        </div>
    </nav>
</template>

<script>
import { mapActions } from 'pinia';
import { usePrefsStore } from '@/stores/preferences';
import SelectField from './form/SelectField.vue';

export default {
    components: {
        SelectField
    },
    inject: [
        'page',
        'from',
        'to',
        'count',
    ],
    emits: [
        'flip',
        'limit-change'
    ],
    methods: {
        ...mapActions(usePrefsStore, ['setPref'])
    },
    props: {
        limits: {
            type: Array,
            default: () => [
                {
                    label: '12',
                    value: 12
                },
                {
                    label: '24',
                    value: 24
                },
                {
                    label: '48',
                    value: 48
                },
                {
                    label: '96',
                    value: 96
                },
                {
                    label: '192',
                    value: 192
                }
            ]
        }
    },
    computed: {
        getLimits() {
            return this.limits;
        },
        max() {
            return Math.ceil(this.count / this.limit);
        },
        limit: {
            get() {
                return usePrefsStore().limit;
            },
            set(value) {
                this.setPref('limit', value);
                this.$emit('limit-change', value);
            }
        }
    }
}
</script>